import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ze-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {
  @Input() filename: any;
  @Input() videoContent: boolean;
  @Input() username: "";
  public isRefreshing:boolean=true;
  constructor() { }

  ngOnInit() {
  this.refreshIframe();
  }

  refreshIframe() {
    this.isRefreshing = true;
    setTimeout(() => {
      this.isRefreshing = false;
    },100);
  }

  onContextMenu() {
    // Prevent right-click context menu (not foolproof)
    return false;
  }

}
